var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnnLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.4 277.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        mask: url(#mask);\n      }\n\n      .st2, .st3 {\n        fill: #333b41;\n      }\n\n      .st4 {\n        opacity: .6;\n      }\n\n      .st4, .st5 {\n        isolation: isolate;\n      }\n\n      .st6 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st7 {\n        fill: #7f92a1;\n        font-family: Poppins-SemiBold, Poppins;\n        font-size: 39.3px;\n        font-weight: 600;\n      }\n\n      .st8 {\n        fill: url(#linear-gradient);\n      }\n\n      .st9 {\n        fill: #333b42;\n      }\n\n      .st10 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st11 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st12 {\n        clip-path: url(#clippath-4);\n      }\n\n      .st13 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st14 {\n        clip-path: url(#clippath-7);\n      }\n\n      .st15 {\n        clip-path: url(#clippath-6);\n      }\n\n      .st16 {\n        clip-path: url(#clippath-8);\n      }\n\n      .st17 {\n        clip-path: url(#clippath-5);\n      }\n\n      .st18 {\n        fill: #fff;\n      }\n\n      .st19 {\n        fill: #00acff;\n      }\n\n      .st3 {\n        fill-rule: evenodd;\n      }\n\n      .st20 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 5.5,
    y: 19.1,
    width: 493.7,
    height: 227.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 5.5,
    y: 19.1,
    width: 493.7,
    height: 227.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 12.4,
    y: 116.3,
    width: 93.2,
    height: 63.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 11.6,
    y: 113.1,
    width: 85.9,
    height: 18.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 10,
    y: 107.1,
    width: 87.5,
    height: 23.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.7,107.4c-3.7.8-17.1,6.9-40.7,17.9.4,1.6,1.2,3.3,1.6,4.9l37-16.7c1.6-.8,3.7-1.2,5.7-.8,2.8.4,5.7.4,8.5.8,1.2,0,1.6,0,2.8.4,1.2.4,1.6.8,2,1.6,2.8,3.3,6.5,5.7,10.6,7.3,6.5,2.4,13,2,19.1-.8-10.2-.8-16.7-2.8-19.9-5.3-5.3-3.7-8.1-6.5-10.2-6.9-1.3-.7-7.4-2.7-13.2-2.7s-2.4,0-3.5.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -255.3,
    y1: 428.1,
    x2: -254.3,
    y2: 428.1,
    gradientTransform: "translate(-11049.7 -18526) rotate(-180) scale(43.6 -43.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0.7,
    y: 72.1,
    width: 106,
    height: 93.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 23.8,
    y: 74.3,
    width: 59.8,
    height: 88.6,
    transform: "translate(-76.4 113.6) rotate(-63.4)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: -255.3,
    y1: 428.1,
    x2: -254.3,
    y2: 428.1,
    gradientTransform: "translate(-11049.7 -18526) rotate(-180) scale(43.6 -43.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7fbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dcedf0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 5.5,
    y: 19.1,
    width: 493.7,
    height: 227.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 192.3,
    y: 190.3,
    width: 50.4,
    height: 56.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 192.3,
    y: 190.3,
    width: 50.4,
    height: 56.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M85.7,19.1c44.3,0,80.2,35.9,80.2,80.2s-35.9,80.2-80.2,80.2S5.5,143.5,5.5,99.2,41.4,19.1,85.7,19.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.4,57.4v-26.9c0-3.7,2.8-6.5,6.5-6.5h33.4c40.7,0,73.7,33,73.7,73.7v80.2c0,3.7-2.8,6.5-6.5,6.5h-26.9c-3.7,0-6.5-2.8-6.5-6.5v-80.2c0-18.3-15.1-33.4-33.4-33.4h-33.8c-3.7,0-6.5-3.3-6.5-6.9M334.5,57.4v-26.9c0-3.7,2.8-6.5,6.5-6.5h33.4c40.7,0,73.7,33,73.7,73.7v80.2c0,3.7-2.8,6.5-6.5,6.5h-26.9c-3.7,0-6.5-2.8-6.5-6.5v-80.2c0-18.3-15.1-33.4-33.4-33.4h-33.4c-4.1,0-6.9-3.3-6.9-6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M204.7,84.3h3.7c9,0,16.3,7.3,16.3,16.3v68c0,9-7.3,16.3-16.3,16.3h-3.7c-9,0-16.3-7.3-16.3-16.3v-68c0-9,7.3-16.3,16.3-16.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M348,84.3h3.7c9,0,16.3,7.3,16.3,16.3v68c0,9-7.3,16.3-16.3,16.3h-3.7c-9,0-16.3-7.3-16.3-16.3v-68c0-9,7.3-16.3,16.3-16.3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M105.6,116.3c-2.4,2.8-5.3,4.9-8.5,6.1l-17.9,9-26-15.1-40.7,15.5c11.8,27.3,38.7,46.4,69.6,47.6l23.6-63.1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M95.4,76c-6.1-2.4-13-2-18.7.4-4.9,2-9,5.7-11.4,10.2l-6.1,6.1c-1.2,0-2.9.4-4.1.4-2,.4-4.1-.4-5.3-2l-12.2-16.3c0-.4-.4-.4-.4-.4-2.8-3.3-7.7-3.7-11-1.2l-19.9,15.1c-.4,3.7-.8,7.3-.8,11s.4,7.7.8,11.4c.8,4.9,2,9.8,3.7,14.7,23.6-11,37-17.1,40.7-17.9,6.5-1.6,15.1,1.6,16.7,2.4,1.6.8,4.9,3.3,9.8,7.3,3.3,2.8,9.8,4.5,19.9,5.3,3.3-1.6,6.1-3.7,8.5-6.1,2-2.4,3.7-4.9,4.9-8.1,4.5-13-2-27.3-15.1-32.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M78.3,123.3c-4.1-1.6-7.7-4.1-10.6-7.3-.4-.4-.8-.8-2-1.6-1.2-.4-1.6-.4-2.8-.4-2.8-.4-5.7-.4-8.5-.8-2,0-3.7,0-5.7.8l-37,16.7c0,.4.4.8.8,1.2l41.1-15.5,26,15.1,17.9-9c-6.1,2.8-12.6,3.3-19.1.8"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M67.4,109.8c-1.6-.8-10.2-3.7-16.7-2.4-3.7.8-17.1,6.9-40.7,17.9.4,1.6,1.2,3.3,1.6,4.9l37-16.7c1.6-.8,3.7-1.2,5.7-.8,2.8.4,5.7.4,8.5.8,1.2,0,1.6,0,2.8.4,1.2.4,1.6.8,2,1.6,2.8,3.3,6.5,5.7,10.6,7.3,6.5,2.4,13,2,19.1-.8-10.2-.8-16.7-2.8-19.9-5.3-5.3-3.7-8.1-6.5-10.2-6.9"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M67.4,109.8c-1.6-.8-10.2-3.7-16.7-2.4-3.7.8-17.1,6.9-40.7,17.9.4,1.6,1.2,3.3,1.6,4.9l37-16.7c1.6-.8,3.7-1.2,5.7-.8,2.8.4,5.7.4,8.5.8,1.2,0,1.6,0,2.8.4,1.2.4,1.6.8,2,1.6,2.8,3.3,6.5,5.7,10.6,7.3,6.5,2.4,13,2,19.1-.8-10.2-.8-16.7-2.8-19.9-5.3-5.3-3.7-8.1-6.5-10.2-6.9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 23.8,
    y: 74.3,
    width: 59.8,
    height: 88.6,
    transform: "translate(-76.4 113.6) rotate(-63.4)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(192.3 223.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "by")))))), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M268.6,223.5c0-5.1,4.2-9.3,9.3-9.3h10.3c.3.4.9.7,1.5.7,1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.1.3-1.5.7h-10.3c-6.4,0-11.6,5.2-11.6,11.6s5.2,11.6,11.6,11.6h26.2c.3.4.9.7,1.5.7,1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.1.3-1.5.7h-26.2c-5.1,0-9.3-4.2-9.3-9.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M310.1,237.3c-.6,0-1.1.3-1.5.7h-30.7c-8,0-14.5-6.5-14.5-14.5s6.5-14.5,14.5-14.5h19.4c.3.4.9.7,1.5.7,1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.1.3-1.5.7h-19.4c-9.3,0-16.8,7.5-16.8,16.8s7.5,16.8,16.8,16.8h30.7c.3.4.9.7,1.5.7,1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M301,242.5c-.6,0-1.1.3-1.5.7h-21.7c-10.9,0-19.7-8.9-19.7-19.7s8.9-19.7,19.7-19.7h14.8c.3.4.9.7,1.5.7,1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.1.3-1.5.7h-14.8c-12.2,0-22,9.9-22,22s9.9,22,22,22h21.7c.3.4.9.7,1.5.7,1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M322.6,222.8c0-9.5,7.2-16.7,16.8-16.7s14.3,5.7,15.5,10.4l-7.7,2.2c-.7-2.6-3.6-5.3-7.8-5.3s-8.6,4.3-8.6,9.4,3.4,9.4,8.6,9.4,7.1-2.5,7.8-5.1l7.7,2.1c-1.2,4.8-6.7,10.4-15.5,10.4s-16.9-7.3-16.9-16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M389.7,207v31.8h-8.3v-4c-2.1,2.8-5.6,4.9-10.2,4.9-8.4,0-12.6-5.6-12.6-14.1v-18.5h8.3v16.9c0,4.8,2.2,8,6.8,8s7.7-3.6,7.7-9.3v-15.7h8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M414.8,206.5v7.8c-6.8-1.1-10.5,2.1-10.5,10.6v13.8h-8.3v-31.8h8.3v4.7c1.9-3.7,5.5-5.8,10.5-5.2h0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st9",
    points: "452.9 207 439.8 238.8 430.4 238.8 417.3 207 426.4 207 435.1 229.6 443.9 207 452.9 207"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M451.6,222.9c0-9.5,7.2-16.8,17.1-16.8s16.9,7.2,16.9,16.8-7.2,16.8-16.9,16.8-17.1-7.3-17.1-16.8M477.5,222.9c0-5.3-3.6-9.3-8.9-9.3s-8.9,3.9-8.9,9.3,3.6,9.3,8.9,9.3,8.9-3.9,8.9-9.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "493.3 207.1 491.7 207.1 491.7 213.9 493.2 213.9 493.2 209.3 495.5 212.5 497.7 209.3 497.7 213.9 499.2 213.9 499.2 207.1 497.6 207.1 495.5 210.2 493.3 207.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "487.1 213.9 488.5 213.9 488.5 208.5 490.8 208.5 490.8 207.1 484.9 207.1 484.9 208.5 487.1 208.5 487.1 213.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnnLogo);
export default __webpack_public_path__ + "static/media/onn-logo.abc03cbfcece6b3443a39f0b6abda9a4.svg";
export { ForwardRef as ReactComponent };